// extracted by mini-css-extract-plugin
export var centerText = "_52-8";
export var container = "_52-0";
export var doughnutContainer = "_52-7";
export var legend = "_52-a";
export var legendItemColorDisplay = "_52-b";
export var legendItemLabel = "_52-d";
export var legendItemValue = "_52-c";
export var lg = "_52-5";
export var maxWidth = "_52-9";
export var md = "_52-4";
export var responsive = "_52-6";
export var sm = "_52-3";
export var xs = "_52-2";
export var xxs = "_52-1";